import { t } from "../i18n";

/**
 * Time a talent has left to answer a "Wasn't played?" claim (founder,
 * 2026-10-09), short enough for a banner line: "2d 23h" from two days out,
 * "47h" inside the last two days, "35m" in the final hour. null once the
 * deadline has passed (the server refunds on its own; nothing to count).
 */
export function claimTimeLeft(deadlineAt: string | null | undefined, now = Date.now()): string | null {
  const end = deadlineAt ? Date.parse(deadlineAt) : NaN;
  if (!Number.isFinite(end) || end <= now) return null;
  const minutes = Math.max(1, Math.floor((end - now) / 60_000));
  const hours = Math.floor(minutes / 60);
  if (hours >= 48) return t("claimTimeLeft.daysHours", { d: Math.floor(hours / 24), h: hours % 24 });
  if (hours >= 1) return t("claimTimeLeft.hours", { h: hours });
  return t("claimTimeLeft.minutes", { m: minutes });
}
